import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, ArrowRight } from "lucide-react";

const daysLeft = (iso) => Math.max(0, Math.ceil((new Date(iso) - new Date()) / 86400000));

// Rappel discret et permanent pendant l'essai (masqué sur la page d'abonnement).
export default function TrialStatusBar() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const access = user?.access;

  if (!access || access.status !== "trial" || !access.trial_ends_at) return null;
  if (pathname.startsWith("/abonnement")) return null;

  const d = daysLeft(access.trial_ends_at);

  return (
    <Link
      to="/abonnement"
      data-testid="trial-status-bar"
      className="group flex items-center justify-center gap-2 bg-[#FFF4DC] px-4 py-2 text-sm text-[#16233D] hover:bg-[#F7E7BE] transition-colors duration-200"
    >
      <Sparkles className="h-4 w-4 text-[#E8899F]" />
      <span className="font-semibold">
        {d === 0 ? "Dernier jour d'essai" : `Il te reste ${d} jour${d > 1 ? "s" : ""} d'essai`}
      </span>
      <span className="hidden sm:inline text-[#23375E]">— garde tout Kynoria à vie pour 47 € au lieu de 57 €</span>
      <span className="inline-flex items-center gap-1 font-semibold text-[#23375E] group-hover:gap-2 transition-all duration-200">
        Voir l'offre <ArrowRight className="h-3.5 w-3.5" />
      </span>
    </Link>
  );
}
